import React, { memo, useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import loopSmileDesignQuestions from '../LoopSmileDesignQuestions';
import { restorationFormQuestion } from './RestorationFormQuestion';
import { useLang } from '../../../util/lang';

const RestorationForm = () => {
    const methods = useFormContext();
    const isMarieGroup = useMemo(() => {
        let value = JSON.parse(localStorage.getItem('isMarieGroup'));
        return value;
    }, []);
    const get = useLang();

    const formValues = useWatch({ control: methods.control });
    const questions = restorationFormQuestion(formValues, isMarieGroup);

    return <>{loopSmileDesignQuestions(questions, formValues, false, get)}</>;
};

export default memo(RestorationForm);
